import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { space, typography, layout } from "styled-system";
import propTypes from "@styled-system/prop-types";
import themeGet from "@styled-system/theme-get";
import { HeaderStyle } from "../header/header.style";

const TogglerStyle = styled("button", {
  inHeader: PropTypes.bool,
  inNavbar: PropTypes.bool,
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  ${({ inHeader }) => inHeader && css`
    min-width: 50px;
    font-size: 18px;
    background-color: transparent;
    border: 0;
    border-radius: 4px;

    @media (hover: hover), (-ms-high-contrast: none) {
      &:hover {
        color: ${themeGet("colors.headerToggler.colorHover", "#3c4b64")};
        text-decoration: none;
      }
    }

    &:focus {
      outline: 0;
    }

    &:not(:disabled) {
      cursor: pointer;
    }

    ${HeaderStyle} & {
      color: ${themeGet("colors.headerToggler.color", "rgba(0, 0, 21, 0.5)")};
      border-color: ${themeGet("colors.headerToggler.borderColor", "rgba(0, 0, 21, 0.1)")};
    }
  `}

  ${({ inNavbar }) => inNavbar && css`
    padding: 4px 12px;
    font-size: 18px;
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 4px;

    &:hover,
    &:focus {
      text-decoration: none;
    }
  `}

  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const TogglerIconStyle = styled("span", {
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  display: block;
  height: 22px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;

  ${HeaderStyle} & {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 21, 0.5)' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
    
    &:hover {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 21, 0.7)' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
    }
  }

  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

export {
  TogglerStyle,
  TogglerIconStyle,
};
